import { ReportTabRulesKey } from '@navstation-portal/reporting/data-model/vessel-report';
import { bunkerEvents } from './bunker/bunker-events';
import { cargoDetailsFormEvents } from './cargo-details/cargo-details-events';
import { consumptionsFormEvents } from './consumptions/consumptions-events';
import { FormStoreEventGroup } from './create-form-store-events';
import { operationalEvents } from './operational/operational-events';
import { positionAndWeatherEvents } from './position-and-weather/position-and-weather-events';
import { powerEvents } from './power/power-events';
import { stockEvents } from './stock/stock-events';

/**
 * The form store events for each tab, keyed by the tab's rules key.
 *
 * Two callers write into a tab's form state without a form control in front of
 * them: the stale-status hook writes a status, and the creation-time carry-over
 * writes a value. Both go through this map, so what they write reaches the
 * state the way a form control reaches it.
 *
 * The map lives in its own module because both callers are features of the
 * report store. A map inside `report.store.ts` would make the carry-over
 * feature import the store that composes it.
 *
 * The type names the two events these callers send, and the init event that
 * the Calculated Value hook listens for, rather than the whole group. A new
 * caller widens it. The key type makes the compiler check that
 * the map holds every form tab. A caller narrows a template tab id with
 * `isReportTabRulesKey` before it reads the map.
 */
export const FORM_STORE_EVENTS: Record<
  ReportTabRulesKey,
  Pick<FormStoreEventGroup, 'updateFormStateStatus' | 'updateFormStateValue' | 'initialiseFormState'>
> = {
  operational: operationalEvents,
  positionAndWeather: positionAndWeatherEvents,
  power: powerEvents,
  cargoDetails: cargoDetailsFormEvents,
  consumption: consumptionsFormEvents,
  bunker: bunkerEvents,
  stock: stockEvents,
};
